module.exports = __webpack_public_path__ + "img/simbolo-erro.a4a4f169.png";